import { render, staticRenderFns } from "./Realtime.vue?vue&type=template&id=77168ea4&"
import script from "./Realtime.vue?vue&type=script&lang=ts&"
export * from "./Realtime.vue?vue&type=script&lang=ts&"
import style0 from "./Realtime.vue?vue&type=style&index=0&id=77168ea4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports